import $ from 'jquery';
import { TagManager } from '@dealersites/tag-manager/tag-manager';

// tag support - but these elements do not exist in atomic
$('.js-price-btn').on('change', function () {
  if ($(this).prop('checked')) {
    const max = $(this).val();
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, 'dsp_price_min', 0);
    newUrl = replaceUrlParam(newUrl, 'dsp_price_max', max);
    newUrl = replaceUrlParam(newUrl, 'price_btn', true);
    window.location.assign(newUrl);
    // tag
    const status = $('.search-results').attr('data-sale-status');
    const config = {
      onclick: {
        onclick: status + ':si:vls:filter:price',
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
      },
    };
    TagManager.trackEvent('global-onclick', config);
  }
});

// tag support - but these elements do not exist in atomic
$('.js-price-input').on('change', function () {
  const value = $(this).val();
  if (parseInt(value)) {
    const param = $(this).data('param');
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, param, value);
    newUrl = replaceUrlParam(newUrl, 'price_input', true);
    window.location.assign(newUrl);
  }
  // tag
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:filter:price',
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

// Tag F-150 - tag support - but this element does not exist in atomic
$('.js-tag-f150').on('click', function () {
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:filter:model',
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
    },
    vehicle: {
      nameplate: 'F-150',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

// Tag Checkbox Filters
$('.inventory-page').on('change', '.filter-container input[type=checkbox]', function () {
  if ($(this).prop('checked')) {
    const nameplates = ['make', 'model', 'year'];
    const status = $('.search-results').attr('data-sale-status');
    let filterType = $(this).parents('.filter-container').attr('id');

    if (filterType === 'engine_type') {
      filterType = 'engine';
    } else if (filterType === 'odometer') {
      filterType = 'mileage';
    }

    const config = {
      onclick: {
        onclick: status + ':si:vls:filter:' + filterType,
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
      },
    };

    if (nameplates.includes(filterType)) {
      const value =
        filterType == 'year'
          ? $(this).siblings('label').text().trim()
          : $(this).siblings('span').text().split('(')[0].trim();
      config.vehicle = {};
      if (filterType == 'year') {
        config.vehicle.modelYear = value;
      } else {
        config.vehicle.nameplate = value;
      }
    }
    TagManager.trackEvent('global-onclick', config);
  }
});

// Tag Sort By Filters
$('.dsp-drop-select').on('change', function () {
  const val = $(this).find(':selected').text().trim();
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:sort by: ' + val,
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:sort',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

// Tag Garage Button
$('.page').on('change', '.vehicle [data-garage-toggle-id]', function () {
  if ($(this).prop('checked')) {
    const model = $(this).data('model');
    const make = $(this).data('make');
    const year = $(this).data('year');
    const status = $(this).data('status');

    const config = {
      onclick: {
        onclick: status + ':si:vls:save',
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:save',
      },
    };

    if (year || model || make) {
      config.vehicle = {};
    }

    if (year) {
      config.vehicle.modelYear = year;
    }

    if (model || make) {
      config.vehicle.nameplate = make + ' ' + model;
    }
    config.page = {};
    config.page.pageName = 'dc:' + status + ':si:vls';
    config.page.pageNameNoVehicle = 'dc:' + status + ':si:vls';
    TagManager.trackEvent('global-onclick', config);
  }
});

// TO Buy Now Tag (SRP)
$('.inventory-page').on('click', '.js-analytics-buy-now', function () {

    const model = $(this).data('model');
    const make = $(this).data('make');
    const year = $(this).data('year');
    const current = $(this).data('current');


    const config = {
      onclick: {
        onclick: 'referral:foc',
        referredTo: current,
        onclickLinkName: 'referral-exit',
      },
    };

    if (year || model || make) {
      config.vehicle = {};
    }

    if (year) {
      config.vehicle.modelYear = year;
    }

    if (model || make) {
      config.vehicle.nameplate = make + ' ' + model;
    }

    config.event = { action: 'brand referral'};

    TagManager.trackEvent('referral-exit', config);  

});
